import { useEffect, useRef, useState } from "react";

import { submittedAt } from "src/lib/submission";
import { formatTimestamp } from "src/lib/time";
import type { QueueEntry } from "src/api/types";

interface Props {
  entry: QueueEntry;
}

export function SubmissionDetails({ entry }: Props) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  function close() {
    setOpen(false);
    buttonRef.current?.focus();
  }

  useEffect(() => {
    if (!open) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") close();
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="kebab-btn"
        aria-label="Submission details"
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <svg width="4" height="16" viewBox="0 0 4 16" fill="currentColor" aria-hidden="true">
          <circle cx="2" cy="2" r="1.75" />
          <circle cx="2" cy="8" r="1.75" />
          <circle cx="2" cy="14" r="1.75" />
        </svg>
      </button>

      {open && (
        <div className="modal-backdrop" onClick={close}>
          <div
            className="modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={`submission-details-${entry.id}`}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              className="modal-title submission-details-title"
              id={`submission-details-${entry.id}`}
            >
              Submissions
            </h3>
            <dl className="submission-details">
              <dt>Insurance card</dt>
              <dd>{formatTimestamp(submittedAt(entry.insurance_card_submitted_at))}</dd>
              <dt>Consents</dt>
              <dd>{formatTimestamp(submittedAt(entry.consents_submitted_at))}</dd>
            </dl>
            <div className="modal-actions">
              <button type="button" className="btn btn-outline" autoFocus onClick={close}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
